var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sale-details"},[_c('div',{staticClass:"sale-detail-label"},[_c('h6',[_vm._v("Sale Total("+_vm._s(_vm.getSaleUnits)+")")])]),_c('div',{staticClass:"sale-detail-value"},[_c('h4',[_vm._v(_vm._s(_vm.$utils.formatMoney((_vm.saleTotal - _vm.discount.total) / _vm.rate, 2 ,'.', ',', true,_vm.symbol)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }